import { Box } from "@mui/material";
import AuthBlankScreen from "./AuthBlankScreen";
import AuthPrimaryButton from "./AuthPrimaryButton";
import { BRAND_BLUE } from "../theme/appTheme";
import { useTranslation } from "../i18n/LanguageContext";

// Shown when an emailed-code flow dies: the code (or the reset session it
// confirmed) came back "invalid or expired" — covers both a genuinely
// expired code and the wrong-guesses cap, which the backend treats
// identically.
//
// titleKey/subtitleKey let a caller override the copy without inventing a
// second component. Default copy includes the mailto contact link.
function ExpiredLinkScreen({ onRetry, retryLabel, titleKey = "auth.expiredLink.title", subtitleKey }) {
  const { t } = useTranslation();
  return (
    <AuthBlankScreen
      title={t(titleKey)}
      subtitle={
        subtitleKey ? (
          t(subtitleKey)
        ) : (
          <>
            {t("auth.expiredLink.contactPrefix")}{" "}
            <Box
              component="a"
              href="mailto:info@sibolab.de"
              sx={{ color: BRAND_BLUE, textDecoration: "underline" }}
            >
              {t("auth.expiredLink.contactLink")}
            </Box>
            .
          </>
        )
      }
      actions={
        <AuthPrimaryButton onClick={onRetry} sx={{ px: 4, width: "auto" }}>
          {retryLabel || t("auth.expiredLink.tryAgain")}
        </AuthPrimaryButton>
      }
    />
  );
}

export default ExpiredLinkScreen;
